import TelemetryButton from "@/design-system/telemetry-button";
import { CbTopBaseResources } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources";
import { CbTopBaseResourcesEn } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources.En";
import { SocialProof } from "@/src/cashback/LandingPage/Version/social-proof";
import { LoginModalView, useActiveLoginModalContext } from "@/src/contexts";
import { languageSelector } from "@/src/contexts/UserAuthenticationContext";
import PanelSection from "@/src/shared/panel-section";
import ImageLoader from "@Components/ImageLoader";
import { getCdnImage } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

import { type QuerySmMax, type QueryXsMax } from "../../../../../styles/tokens.stylex";

import * as css from "./../../CashbackTopSection.module.css";

export function LpTopComponentVersionB() {
    const ME_VERISON = "B";

    const resources = languageSelector(CbTopBaseResources, CbTopBaseResourcesEn);

    const { setActiveLoginModal } = useActiveLoginModalContext();

    const openRegistration = () => setActiveLoginModal(LoginModalView.Registration);

    return (
        <PanelSection
            telemetryCustom={{
                eventName: "cshbck-TopSection",
                actionType: "View",
                param1: ME_VERISON,
            }}
            initialInView
        >
            <div className={css.cashbackTopSectionComponent}>
                <div className={css.textContent}>
                    <h1 className={css.subject} dangerouslySetInnerHTML={{ __html: resources.title }} />

                    <SocialProof />

                    <TelemetryButton
                        as="button"
                        variant="magentaRound"
                        size="L"
                        eventName="cshbck-topSectionRegister"
                        param1={ME_VERISON}
                        onClick={openRegistration}
                        styleX={styles.registerButton}
                    >
                        {resources.registerText}
                    </TelemetryButton>
                </div>
                <div {...stylex.props(styles.imageWrapper)}>
                    <ImageLoader
                        src={getCdnImage(process.env.CB_TopSection)}
                        alt="Cashback - zwroty pieniędzy za zakupy"
                    />
                </div>
            </div>
        </PanelSection>
    );
}

const xsMax: QueryXsMax = "@media (max-width: 759px)";
const smMax: QuerySmMax = "@media (max-width: 989px)";

const styles = stylex.create({
    imageWrapper: {
        height: { default: "auto", [smMax]: 380, [xsMax]: 284 },
        width: { default: "50%", [smMax]: "100%" },
    },
    registerButton: {
        marginTop: { default: 50, [xsMax]: 30 },
    },
});
